import { ActiveMetricTabs } from '@/Enums/Attribution/ActiveMetricTabs.enum';
import ButtonSize from '@/Enums/ButtonSize.enum';
import { IChannelReportRecord } from '@/Interfaces/Attribution/ReportRecord.interface';
import { CapturePDFButton } from '@/components/Buttons/CapturePDFButton';
import { DownloadButton } from '@/components/Buttons/DownloadButton';
import SwitchTableButton from '@/components/Buttons/SwitchTableButton';
import { getDoughnutGraphData } from '@/helpers/attribution/chartData';
import { downloadCSV } from '@/helpers/downloadCSV';
import { getDocumentTitle } from '@/helpers/printing';
import { useAppSelector } from '@/store/hooks';
import { selectWebVisitsChannelData } from '@/store/selectors/attribution/webVisits.selectors';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import DoughnutChart from '../Charts/DoughnutChart';

const label = 'Digital Channel';
const legendContainerId = 'digital-channel';

const ChannelCard = () => {
  const printContainerRef = useRef<HTMLDivElement>(null);
  const [activeMetric, setActiveMetric] = useState<ActiveMetricTabs>(ActiveMetricTabs.Impression);

  const { channelData, channelDataLoading } = useAppSelector(selectWebVisitsChannelData);

  const { csvData, chartData, loading } = useMemo(
    () => getDoughnutGraphData<IChannelReportRecord>(activeMetric, label, channelData, channelDataLoading),
    [activeMetric, channelData, channelDataLoading],
  );

  const handlerClick = useCallback(() => {
    downloadCSV(csvData, label);
  }, [csvData]);

  const handlePrint = useReactToPrint({
    documentTitle: getDocumentTitle(label),
    content: () => printContainerRef.current,
  });

  return (
    <div className='flex flex-col h-full w-full print:p-8' ref={printContainerRef}>
      <div className='flex justify-between'>
        <div className='text-lg text-[#2E2C34] font-semibold'>{label}</div>
        <div className='space-x-[6px] flex-row flex'>
          <SwitchTableButton
            value={activeMetric}
            onChange={setActiveMetric}
            tabNames={Object.values(ActiveMetricTabs)}
          />
          <DownloadButton disabled={loading} onClick={handlerClick} size={ButtonSize.Medium} />
          <CapturePDFButton disabled={loading} onClick={handlePrint} size={ButtonSize.Medium} />
        </div>
      </div>
      <DoughnutChart chartData={chartData} loading={loading} legendContainerId={legendContainerId} />
    </div>
  );
};

export default ChannelCard;
